var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m4 4 16 16m-6-5.764A3 3 0 0 1 9.764 10m9.844 5.608a22.432 22.432 0 0 0 1.522-1.461 3.085 3.085 0 0 0 0-4.294C19.175 7.795 15.816 5 12 5c-.891 0-1.758.153-2.587.413M6.5 6.803c-1.458.931-2.702 2.074-3.63 3.05a3.085 3.085 0 0 0 0 4.294C4.826 16.205 8.185 19 12 19c1.868 0 3.627-.67 5.165-1.596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHidden);
export default __webpack_public_path__ + "static/media/eye_hidden.5f35626fc3aa465ad0b5fa808e2c7ea7.svg";
export { ForwardRef as ReactComponent };